module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_vestland_neg.23573b7a.pdf";